import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Navigate } from "react-router";
import { Link } from "react-router-dom";

// import { AddSubjectButtonContainer } from "../Subjects/AddSubject/ButtonContainer";
import { NewSubjectButtonContainer } from "../Subjects/NewSubject/ButtonContainer";
import LiveSearchInput      from '../Subjects/AddSubject/LiveSearchInput/LiveSearchInput';

import { SubjectList } from "../../Component/SubjectList";
import "./style.css";

class SubjectsIndex extends Component<any, any> {
    
    constructor(props: any) {
        super(props);

        this.state = {
            loadQuizzer: undefined,
            loadSubject: undefined
        };

        this.markComplete = this.markComplete.bind(this);
        this.showSubject = this.showSubject.bind(this);
        this.quizSubject = this.quizSubject.bind(this);
        this.removeSubject = this.removeSubject.bind(this);
        this.loginAsGuest = this.loginAsGuest.bind(this);
    }
    
    public handleSearch() {
        console.log("Search Not yet implemented");
    }

    public componentDidMount() {
        if (this.props.rootStore.profileStore.authTokenSet()) {
            this.props.rootStore.subjectStore.fetch();
        } else {
            this.props.rootStore.subjectStore.fetchFreeLanding();
        }
    }

    public removeSubject(subject_hash_key: string) {
        this.props.rootStore.subjectStore.remove_subject(subject_hash_key);
    }

    public loginAsGuest() {
        this.props.rootStore.profileStore.loginAsGuest();
    }

    public markComplete(subjectHashKey: string) {
        this.props.rootStore.subjectStore.markComplete(subjectHashKey);
    }

    public showSubject(subjectHashKey: string) {
        this.setState({
            loadSubject: subjectHashKey
        });
    }

    public quizSubject(subjectHashKey: string) {
        this.setState({
            loadQuizzer: subjectHashKey
        });
    }

    public getOffSubjectHash(subjects: any, subject_hash_key: string, key: string) {
        let subj = subjects.get(subject_hash_key);
        if (subj != undefined) {
            return subjects.get(subject_hash_key)[key];
        } else {
            return "";
        }
    }

    public render() {
        if (this.state.loadSubject) {
            return <Navigate to={`/modquiz/subject/${this.state.loadSubject}`} />;
        }

        if (this.state.loadQuizzer) {
            return <Navigate to={`/modquiz/quiz/${this.state.loadQuizzer}`} />;
        }

        const signedIn = this.props.rootStore.profileStore.authTokenSet();
        const subjects = signedIn
            ? this.props.rootStore.subjectStore.userSubjects
            : this.props.rootStore.subjectStore.subjects;
        console.log("User Subjects in SubjectIndex");
        console.log(subjects.values());
        return (
            <div className="container modquiz-study-index">
                <div className="SubjectList">
                    <header>
                        <div>
                            {!signedIn && <p className="modquiz-eyebrow">Open study sets</p>}
                            <h1 className={signedIn ? "modquiz-study-heading" : undefined}>{signedIn ? "What you're studying" : "Try one of these subjects"}</h1>
                            {!signedIn && <p className="modquiz-deck">
                                Choose a subject below, or <Link to="/login">log in</Link> to create your own.
                            </p>}
                        </div>
                        {signedIn && <div className="modquiz-study-actions">
                        <span className="row-items">
                                <NewSubjectButtonContainer
                                    show={this.props.rootStore.profileStore}
                                />
                                <LiveSearchInput handleSearch={this.handleSearch}/>

                                {/* <AddSubjectButtonContainer
                                    show={this.props.rootStore.profileStore}
                                /> */}
                            </span>

                        </div>}
                    </header>
                    <SubjectList
                        subjects={subjects}
                        quiz={this.quizSubject}
                        markComplete={this.markComplete}
                        showSubject={this.showSubject}
                    />
                </div>
                <br />
                <br />
            </div>
        );
    }
}

export default observer(SubjectsIndex);
